<template>
  <div class="grid-y flex-grow divide-y">
    <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
      <RouterTabs :tabs="tabs"/>
      <div
        class="flex flex-row items-center space-x-10"
        v-if="$route.name === 'customers.details.info'">
        <template v-if="customer">
          <template v-if="$delve(customer, 'blockingReason') === null">
            <span
              class="text-16px leading-18px text-danger font-bold cursor-pointer"
              v-b-modal="'disconnect'">
              Заблокировать
            </span>
          </template>
          <template v-else>
            <span
              class="text-16px leading-18px text-primary font-bold cursor-pointer"
              @click="unblock">
              Подключить
            </span>
          </template>
          <span
            class="text-16px leading-18px text-danger font-bold cursor-pointer"
            v-b-modal="'user-delete'">
            Удалить
          </span>
        </template>
      </div>
    </div>
    <div class="cell auto flex">
      <div class="grid-x flex-grow">
        <div class="cell auto cell-block-y flex flex-grow">
          <router-view :id="id"></router-view>
        </div>
      </div>
    </div>
    <UserBlockingModal @block="block"/>
    <UserDeleteModal @delete="userDelete"/>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import RouterTabs from '@/components/RouterTabs.vue';
import UserBlockingModal from '@/components/User/UserBlockingModal.vue';
import UserDeleteModal from '@/components/User/UserDeleteModal.vue';

export default {
  components: {
    RouterTabs,
    UserBlockingModal,
    UserDeleteModal,
  },
  computed: {
    ...mapGetters({
      customers: 'customers/customers',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    customer() {
      return this.customers(this.id);
    },
    tabs() {
      return [
        {
          title: 'Информация',
          push: {
            name: 'customers.details.info',
            params: {
              id: this.id,
            },
          },
        },
        {
          title: 'Список заказов',
          push: {
            name: 'customers.details.orders',
            params: {
              id: this.id,
            },
          },
        },
        {
          title: 'Список объектов',
          push: {
            name: 'customers.details.objects',
            params: {
              id: this.id,
            },
          },
        },
        {
          title: 'Коммуникации',
          push: {
            name: 'customers.details.communications',
            params: {
              id: this.id,
            },
          },
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetch: 'customers/ACT_FETCH_CUSTOMER',
      setBlocking: 'customers/ACT_SET_CUSTOMER_BLOCKING',
      deleteCustomer: 'customers/ACT_DELETE_CUSTOMER',
    }),
    unblock() {
      this.setBlocking({
        id: this.id,
        reason: null,
      });
    },
    block(event) {
      this.setBlocking({
        id: this.id,
        reason: event,
      }).finally(() => {
        this.$bvModal.hide('disconnect-data');
      });
    },
    userDelete() {
      this.deleteCustomer(this.id).then(() => {
        this.$router.push({
          name: 'customers',
        });
      });
    },
  },
  watch: {
    id: {
      handler(value) {
        if (value) {
          this.fetch(value);
        }
      },
      immediate: true,
    },
  },
};
</script>
